<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <multi-search ref="MultiSearch" :key="$route.params.id" :fields="multiFields"></multi-search>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between" style="flex-wrap:wrap">
                    <el-col style="width:auto" id="btnsone">
                        <el-dropdown>
                            <el-button type="primary">批量操作<i class="el-icon-caret-bottom el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="multiArrangement">批量面试安排</el-dropdown-item>
                                <el-dropdown-item @click.native="multiChangePosition(idStr)">批量修改职位</el-dropdown-item>
                                <el-dropdown-item @click.native="syncToSupplier(idStr)">批量同步供应商</el-dropdown-item>
                                <el-dropdown-item @click.native="multiRemarkEdit(idStr)">批量修改备注</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button icon="el-icon-my-mianshianpai" :plain="true" type="primary"
                                   @click="$refs.myArrangement.show()">我的面试安排
                        </el-button>
                        <el-dropdown class="ml-10 mr-10">
                            <el-button icon="el-icon-my-daochu" type="info">导出简历<i
                                    class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportFiles(idStr)">导出已选记录(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportFiles(idStr, undefined, undefined, 'type=HTML')">导出已选记录(html)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/employ/exportAllResume.api?employPhase='+Number($route.params.id-1))">
                                    导出所有查询结果(excel)
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/employ/exportAllResume.api?employPhase='+Number($route.params.id-1), 'HTML')">
                                    导出所有查询结果(html)
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-button v-if="false" icon="el-icon-my-daochu" :plain="true" type="primary" @click="download()">导出面试评价</el-button>
                        <export-custom-dialog :valid-call-back="customExportValid"
                                              :params-call-back="customExportParams"></export-custom-dialog>
                    </el-col>
                    <el-col style="width:auto"  id="btnstwo">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button @click="resetInterview(idStr)"
                                       type="danger">重置面试安排
                            </el-button>
                            <el-button @click="changeStatus(idStr,'pass')" icon="el-icon-my-queding color-success"
                                       type="success" :plain="true">通过
                            </el-button>
                            <el-button @click="changeStatus(idStr,'undetermined')" icon="el-icon-my-daiding color-warning"
                                       type="warning" :plain="true">待定
                            </el-button>
                            <el-button @click="changeStatus(idStr,'notPass')" icon="el-icon-my-guanbi color-danger"
                                       type="danger" :plain="true">淘汰
                            </el-button>
                            <el-button @click="changeStatus(idStr,'lh')" icon="el-icon-my-lahei color-purple" type="purple"
                                       :plain="true">拉黑
                            </el-button>
                            <el-button @click="changeStatus(idStr,'back')" icon="el-icon-my-huitui color-info" type="info"
                                       :plain="true">回退
                            </el-button>
                            <el-button @click="changeStatus(idStr,'fq')" icon="el-icon-my-guanbi color-danger"
                                       type="danger" :plain="true">放弃
                            </el-button>
                            <el-button @click="changeStatus(idStr,'entry')" icon="el-icon-my-queding color-success"
                                       type="success" :plain="true">进入入职
                            </el-button>
                            <el-button @click="checkPaymentData" icon="el-icon-my-queding color-success"
                                       type="success" :plain="true" v-if="$store.state.user.paymentFlag">进入定薪
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                fixed
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                align="center"
                                fixed
                                min-width="120">
                            <template slot-scope="scope">
                                <span
                                    class="name-txt eclip-name-txt"
                                    :title="scope.row.resumeForm.name"
                                    @click="toResumeDetail(scope.row)"
                                >
                                    {{ scope.row.resumeForm.name }}
                                </span>
                                <el-tag type="success" v-if="scope.row.iaId > 0" title="已安排面试" class="pull-right">排
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.gender"
                                label="性别"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="70">
                            <template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
                        </el-table-column>
                        <el-table-column
                                label="岗位"
                                align="center"
                                class-name="no-wrap"
                                min-width="120">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" :content="getPositionTipText(scope.row)" placement="top"
                                            v-if="scope.row.oldPositionName || scope.row.newPositionName">
                                    <el-button type="text" icon="el-icon-my-xinxi"></el-button>
                                </el-tooltip>
                                <span :title="scope.row.positionForm.name">{{ scope.row.positionForm.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.mobilePhone"
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column prop="resumeForm.email" :show-overflow-tooltip="true" label="邮箱"
                                         align="center"
                                         min-width="130">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.email || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.major"
                                label="最高学历"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.school"
                                label="最高学历学校"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.resumeMaxEducation.major"
                                label="专业"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="140">
                        </el-table-column>
                        <el-table-column prop="source" :show-overflow-tooltip="true" label="简历来源" align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                {{scope.row.resumeForm && transToText('WB_RESUME_SOURCE',
                                scope.row.resumeForm.resumeSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='当前所在地'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.residence || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="应聘城市"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="positionForm.sourceFrom"
                                label="投递渠道"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{scope.row.resumeForm && getSelectMapText('WB_ADD_SOURCE',
                                scope.row.resumeForm.addSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投递人"
                                prop="resumeForm.addName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                label="推荐人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.resumeForm.recommenderUser">{{scope.row.resumeForm.recommenderUser.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="游戏经验"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.gameExperience }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="简历附件"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                <attach-view-in-list
                                        :attachList="scope.row.resumeForm.resumeAttachList"></attach-view-in-list>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
                        </el-table-column>
                        <el-table-column
                                label="状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" :content="scope.row.operateReason" placement="top-start"
                                            v-if="scope.row.operateReason">
                                    <el-button type="text" icon="el-icon-my-xinxi">{{getStatusText(scope.row)}}
                                    </el-button>
                                </el-tooltip>
                                <span v-else>{{getStatusText(scope.row)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="同步供应商"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <span>{{getSelectMapText('WB_SYNC_STATUS', scope.row.resumeForm.isSync)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                width="180">
                            <template slot-scope="scope">
                                <el-dropdown @command="handleCommand" class="mr-5" :hide-on-click="false">
                                    <span class="el-dropdown-link">面试评估</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="`${scope.row.id}/pass`"><i
                                                class="el-icon-my-queding color-success mr-10"></i>通过
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/undetermined`"><i
                                                class="el-icon-my-daiding color-warning mr-10"></i>待定
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/notPass`"><i
                                                class="el-icon-my-guanbi color-danger mr-10"></i>淘汰
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/lh`"><i
                                                class="el-icon-my-lahei color-purple mr-10"></i>拉黑
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/back`"><i
                                                class="el-icon-my-huitui color-info mr-10"></i>回退
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/fq`"><i
                                                class="el-icon-my-guanbi color-danger mr-10"></i>放弃
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/entry`"><i
                                                class="el-icon-my-queding color-success mr-10"></i>进入入职
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/payment`" v-if="$store.state.user.paymentFlag&&scope.row.positionForm.paymentState==1"><i
                                                class="el-icon-my-queding color-success mr-10"></i>进入定薪
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <router-link :to="getArrangementUrl(scope.row.id)">面试安排</router-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="备注"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <remark-edit :id="scope.row.resumeForm.id"
                                             v-model="scope.row.resumeForm.remark"></remark-edit>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" label="最近操作人"
                                         align="center"
                                         min-width="130">
                            <template slot-scope="scope">
                                <div style="font-size: 12px;">
                                    <p>{{scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name : ''}}</p>
                                    <p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
        <MyArrangementListDialog ref="myArrangement"></MyArrangementListDialog>
        <change-position-dialog ref="changePositionDialog" @reload="fetchData"></change-position-dialog>
        <multi-remark-edit-dialog ref="multiRemarkEditDialog" @reload="fetchData"></multi-remark-edit-dialog>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import operationMixin from '../operation/operationMixin'
    import RemarkEdit from '../operation/remarkEditDialog.vue'
    import MultiRemarkEditDialog from '../operation/multiRemarkEditDialog.vue'
    import queryListMixin from '../operation/queryListMixin'
    import MyArrangementListDialog from '../operation/myArrangementListDialog'
    import ChangePositionDialog from 'views/operation/changePositionDialog'
    import AttachViewInList from '../operation/attachViewInList.vue'
    import { dateFormat } from 'modules/tools'
    import _ from 'underscore'
    import qs from 'qs'
    import MultiSearch from 'views/common/multiSearch'

    export default {
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin, queryListMixin],
        components: {
            MyArrangementListDialog, AttachViewInList, ChangePositionDialog, RemarkEdit, MultiSearch, MultiRemarkEditDialog
        },
        // 路由保存的搜索条件不包括 pageIndex 和 pageSize
        beforeRouteUpdate (to, from, next) {
            if(to.params.id && from.params.id && to.params.id !== from.params.id) {
                to.query.pageIndex = null
                to.query.pageSize = null
            }
            next()
        },
        data () {
            return {
                fetchUrl: '/employ/list.api',
                RESUME_STATUS_ALL: [],
                multiFields: [{
                    filter: 'WB_RESUME_STATUS_INTERVIEW',
                    label: '简历状态',
                    data: [],
                    mode: 'select',
                    name: 'statusSearch'
                }, {
                    filter: 'WB_INTERVIEW_STATUS',
                    label: '面试安排',
                    data: [],
                    mode: 'select',
                    name: 'interviewStatusSearch'
                }, {
                    filter: 'WB_SYNC_STATUS',
                    label: '是否同步',
                    multiple: false,
                    data: '',
                    mode: 'select',
                    name: 'isSync'
                }]
            }
        },
        methods: {
            multiRemarkEdit(ids) {
                if (this.checkDataValid(ids)) {
                    let $target = this.$refs.multiRemarkEditDialog
                    let rids = this.lists
                        .filter(cv => {
                            return ids.indexOf(cv.id) > -1
                        })
                        .map(cv => {
                            return cv.resumeForm.id
                        })
                        .join(',')
                    $target && $target.show(rids)
                }
            },
            dateFormat (date, format = 'yyyy/MM/dd') {
                return dateFormat(date, format)
            },
            transToText (base, value) {
                let target = _.findWhere(this.selectMap[base], {value: value + ''})
                return (target && target.text) || ''
            },
            multiArrangement () {
                if (!this.checkDataValid(this.idStr)) {
                    return false
                }
                this.$router.push({name: 'multiArrangement', params: {ids: this.idStr}})
            },
            download () {
                let paramsStr = qs.stringify(Object.assign({
                    ids: this.idStr
                }, this.searchData))
                window.open(`${this.$axios.defaults.baseURL}/employ/exportEvaluation.api?token=${this.$store.state.app.token}&${paramsStr}`)
            },
            fetchCallback (res) {
                this.RESUME_STATUS_ALL = res.result.FLOW_STATUS_EMPLOY_TURN_TYPE
                this.$store.commit('UPDATE_SELECT_MAP_DATA', {WB_RESUME_STATUS_INTERVIEW: res.result.FLOW_STATUS_EMPLOY_TURN_TYPE})
                this.$refs.MultiSearch && this.$refs.MultiSearch.$forceUpdate()
            },
            resetSearchDateBeforeFetch () {
                if(this.$route.params.id === '0') {
                    return true
                }
                // 过滤掉“已推荐转岗”这个状态
                const statusSearch = this.searchData.statusSearch ? this.searchData.statusSearch.replace(/10000[,]?/, '') : ''
                if (statusSearch) {
                    let phase = parseInt(statusSearch.substr(0, 1))
                    let id = parseInt(this.$route.params.id) - 1                
                    if (id !== phase) {
                        this.searchData.statusSearch = ''
                        this.searchData.isJobTransfer = ''
                        this.$router.replace({
                            query: {
                                ...this.$route.query,
                                statusSearch: '',
                                isJobTransfer: '',
                            }
                        })
                        return true
                    }
                }
                return true
            },
            extendParamsBeforeFetch () {
                let interviewId = parseInt(this.$route.params.id)
                if(interviewId === 0) {
                    return {
                        turnType: `RESUME_STATUS_${interviewId + 1}`,
                    }
                }
                return {
                    turnType: `RESUME_STATUS_${interviewId + 1}`,
                    employPhase: `${interviewId - 1}`
                }
            },
            recommendResume (item) {
                this.$refs.recommendResumeDialog.show(item)
            },
            getArrangementUrl (id, from = this.$route.name, turn = this.$route.params.id) {
                return `/arrangement/${id}?fromName=${from}&turn=${turn}`
            },
            checkPaymentData () {
                let names = [], namesObj = {}
                this.multipleSelection.forEach(item => {
                    if (item.positionForm.paymentState !== 1 && !namesObj[item.positionForm.name]) {
                        namesObj[item.positionForm.name] = true
                        names.push(item.positionForm.name)
                    }
                })
                if (names.length === 0) {
                    this.changeStatus(this.idStr, 'payment')
                } else {
                    let str = []
                    const h = this.$createElement
                    str.push(h('p', {style: 'color: #000'}, `以下职位尚未设置定薪规则，请先设置后再操作定薪：`))
                    str.push(h('p', {style: 'color: #ff0000'}, `${names.join('、')}`))
                    let target = event.target
                    if(target.nodeName === 'SPAN' || target.nodeName === 'I') {
                        target = event.target.parentNode
                    }
                    target.blur()
                    this.$msgbox({
                        customClass: 'resume-state-wpr',
                        title: `提示`,
                        confirmButtonText: '我知道了',
                        message: h('div', null, str),
                        type: 'warning'
                    })
                }
            },
            toResumeDetail (row) {
                let path = this.getResumeDetailUrl(row.id, row.status) + `&turn=${this.$route.params.id}`

                let routeData = this.$router.resolve({ path })
                window.open(routeData.href, '_blank')
            },
            getPositionTipText(row) {
                const { oldPositionName, newPositionName, isJobTransfer } = row

                if (isJobTransfer == 1 && newPositionName) {
                    // 已转岗
                    return `已转岗到${newPositionName}职位`
                } else {
                    // 最新数据
                    return `转岗前：${oldPositionName}职位`
                }
            },
            getStatusText(row) {
                if (row.isJobTransfer == 1) {
                    return '已转岗'
                }

                return this.getSelectMapText(this.RESUME_STATUS_ALL, row.status)
            }
        }
    }
</script>
<style type="text/css" lang="scss">
// @media screen and (max-width:1630px){
//     #btnsone{
//         transform: scale(0.9)
//     }
//     #btnstwo{
//         transform: scale(0.9)
//     }
// }
</style>



// WEBPACK FOOTER //
// interviewList.vue?483b3976